import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Custom hook to track page changes and trigger Google Analytics events
 * This hook should be used at the router level to track all page navigation
 */
export const usePageTracking = () => {
  const location = useLocation()

  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'ga_trigger',
        page_location: window.location.href,
        page_path: location.pathname + location.search,
        page_title: document.title,
      })
    }
  }, [location.pathname])
}

export default usePageTracking
